export default {
  Form_Tips_Common: {
    enter_clinc_name: '請輸入診所名稱',
    enter_clinc_code: '請輸入診所編碼',
    enter_details_address: '請輸入詳細地址',
    enter_phone: '請輸入電話',
    select_administrator: '請選擇管理員',
    letter_letters_numbers: '以字母開頭，大小寫字母、數字及「-」之組合',
    QingShuRu_JingZhong: '請輸入淨重(如:200g)',
  },
}
